import { strapiInstance } from '@/constants/axios.instances.constants';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import { buildStrapiUrl, loadAbort } from '@/utils';
import type { ProductCatalog, StrapiListRequest, StrapiListResponse } from '@/interfaces/strapi';
import type { ProductCatalogModel, StrapiResponseModel } from '@/interfaces/model';
import { productCatalogListMapper } from '@/mappers';

export const getCatalogProducts = ({
	pagination,
	filter,
	sort,
	populate,
}: StrapiListRequest): UseApiCall<StrapiListResponse<ProductCatalog>> => {
	const controller = loadAbort();

	const url = buildStrapiUrl({
		base: '/productos-catalogos',
		pagination,
		filter: typeof filter === 'object' ? filter : undefined,
		sort,
		populate,
	});

	return {
		call: strapiInstance.get(url, {
			signal: controller.signal,
			transformResponse: [
				(raw: string) => {
					const json = JSON.parse(raw) as StrapiResponseModel<ProductCatalogModel>;
					return productCatalogListMapper(json);
				},
			],
		}),
		controller,
	};
};
